export const DEFAULTS = {
  polling: { intervalMs: 2000, batchSize: 5 },
  concurrency: { maxJobs: 2 },
  logging: { level: 'info' as const, format: 'pretty' as const },
};
